import { Route as RouteDOM, Switch as SwitchDOM, SwitchProps } from 'react-router-dom';
import { Children, ReactElement } from 'react';

import { useRewrite } from './useHistory';

export function Switch(props: SwitchProps) {
	const rewrite = useRewrite();

	function rewriteAll(path: string[] | string | undefined) {
		return path
			? Array.isArray(path)
				? path.map((path) => rewrite(path))
				: rewrite(path)
			: undefined;
	}

	return (
		<SwitchDOM
			{...props}
			// This is fine if you know what you are doing
			// See last point in the following comment
			// https://github.com/airbnb/javascript/issues/1089#issuecomment-250640742
			// eslint-disable-next-line react/no-children-prop
			children={Children.map(
				props.children,
				(child) =>
					child && (
						<RouteDOM
							{...(child as ReactElement).props}
							path={rewriteAll((child as ReactElement).props.path)}
						/>
					),
			)}
		/>
	);
}
